
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="覆盖语言包" fileName="cover-lang.md" />
        <p>通过 <code>VeLocale.update</code> 方法可以实现文案的修改和扩展</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;div&gt;
            &lt;button class=&quot;button-demo&quot; @click=&quot;coverLang()&quot;&gt;修改文案&lt;/button&gt;
            &lt;br /&gt;
            &lt;br /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;ve-pagination :total=&quot;600&quot; /&gt;
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        methods: {
            coverLang() {
                const lang = {
                    pagination: {
                        goto: &quot;跳转到&quot;,
                    },
                };
                this.$veLocale.update(lang);
            },
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('div',[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.coverLang()}}},[_vm._v("修改文案")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',[_c('ve-pagination',{attrs:{"total":600}})],1)])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        methods: {
            coverLang() {
                const lang = {
                    pagination: {
                        goto: "跳转到",
                    },
                };
                this.$veLocale.update(lang);
            },
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  